import { _ as _nodeResolve_empty } from './node-resolve_empty.js';
import { g as getAugmentedNamespace } from './commonjsHelpers.js';

var require$$0 = /*@__PURE__*/getAugmentedNamespace(_nodeResolve_empty);

export { require$$0 as r };
